var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apolloClient from 'app/domains/apollo';
import { htmlToPdfMutation } from './mutation';
import { getCompanyId } from '../getCompanyId';
import { getDocumentRenderInput } from '../getDocumentRenderInput';
export function renderHtmlToPdf(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { documentId, name } = options;
        const companyId = yield getCompanyId();
        const { content, logoUrl } = yield getDocumentRenderInput(documentId, true);
        const { data } = yield apolloClient.mutate({
            mutation: htmlToPdfMutation,
            variables: {
                companyId: companyId || '',
                content,
                logoUrl,
                name,
            },
        });
        const { response } = data || {};
        const [fileToDownload] = response || [];
        const { signed } = fileToDownload || {};
        if (!(signed === null || signed === void 0 ? void 0 : signed.url)) {
            throw Error('No signed url returned from API');
        }
        return signed.url;
    });
}
